import type { WrapperProps } from '~/types'

export const Header = ({ children, className = '' }: WrapperProps) => (
  <div className="container mx-auto">
    <div className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
      {children}
    </div>
  </div>
)
